var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { device } from '../../breakpoints';
export var Grid = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: repeat(", ", 1fr);\n  grid-column-gap: 0.75rem;\n  grid-row-gap: ", ";\n  width: 100%;\n  @media ", " {\n    grid-template-columns: repeat(", ", 1fr);\n  }\n"], ["\n  display: grid;\n  grid-template-columns: repeat(", ", 1fr);\n  grid-column-gap: 0.75rem;\n  grid-row-gap: ", ";\n  width: 100%;\n  @media ", " {\n    grid-template-columns: repeat(", ", 1fr);\n  }\n"])), function (props) { return props.columns; }, function (_a) {
    var isSubNav = _a.isSubNav;
    return (isSubNav ? '0' : '0.75rem');
}, device.laptop, function (props) { return props.columnsMobile; });
export var NavCardGrid = function (_a) {
    var _b = _a.columns, columns = _b === void 0 ? 3 : _b, _c = _a.columnsMobile, columnsMobile = _c === void 0 ? 1 : _c, isSubNav = _a.isSubNav, children = _a.children;
    return (React.createElement(Grid, { columns: columns, columnsMobile: columnsMobile, isSubNav: isSubNav }, children));
};
var templateObject_1;
